import React from 'react';
import PropTypes from 'prop-types';
import joinClassNames from "../../common/JoinClassNames";

const propTypes = {
	// the columns to show
	columns: PropTypes.array.isRequired,

	// if true then add droptarget/source to render
	isDragDrop: PropTypes.bool,

	// callback when the row is clicked: record => {}
	onRowClick: PropTypes.func,

	// callback when the row is double clicked: record => {}
	onRowDoubleClick: PropTypes.func,

	// callback when the row is updated (for hooking up delete buttons)
	onRowUpdate: PropTypes.func,

	// the record to show
	record: PropTypes.object.isRequired,

	// is this row currently selected? gets selected added class
	isSelected: PropTypes.bool,

	// css classes for the row
	trClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

const defaultProps = {
	isDragDrop: false,
	onRowClick: undefined,
	onRowDoubleClick: undefined,
	onRowUpdate: undefined,
	isSelected: false,
	trClassName: undefined,
};

export default class Row extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			mouseOver: false,
		}
	}
	componentDidUpdate() {
		if (this.props.onRowUpdate) {
			this.props.onRowUpdate(this.props.record);
		}
	}

	classNameMaybeFunc(className) {
		return className ? typeof className === 'string' ? className : className(this.props.record) : undefined;
	}

	renderRow() {
		return (
			<tr
				onClick={this.props.onRowClick ? e => this.props.onRowClick(this.props.record, e) : undefined}
				onDoubleClick={this.props.onRowDoubleClick ? e => this.props.onRowDoubleClick(this.props.record, e) : undefined}
				className={joinClassNames(
					this.props.isSelected && 'selected',
					this.state.mouseOver && 'mouse-over',
					this.classNameMaybeFunc(this.props.trClassName),
					this.props.isOver && 'drag-drop-is-over'
				)}
				onMouseEnter={() => this.setState({mouseOver: true})}
				onMouseLeave={() => this.setState({mouseOver: false})}
        		onDragEnd={() => this.setState({mouseOver: false})}
			>
				{this.props.columns.map(c =>
					c.tdCallback ? c.tdCallback(c, this.props.record) :
						<td
							className={this.classNameMaybeFunc(c.tdClassName)}
							key={c.field ? c.field : c.key}>
							{this.props.record[c.field]}
						</td>
				)}
			</tr>
		);
	}

	render() {
		return this.props.isDragDrop ? this.props.connectDropTarget(this.props.connectDragSource(this.renderRow())) : this.renderRow();

	}
}

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;
